import { render, staticRenderFns } from "./paymentFailed.vue?vue&type=template&id=3a29ffae&scoped=true&"
import script from "./paymentFailed.vue?vue&type=script&lang=js&"
export * from "./paymentFailed.vue?vue&type=script&lang=js&"
import style0 from "./paymentFailed.vue?vue&type=style&index=0&id=3a29ffae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a29ffae",
  null
  
)

export default component.exports